"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMS_FIELD_PLUGIN_ID = void 0;
exports.CMS_FIELD_PLUGIN_ID = 'cms';
//# sourceMappingURL=fieldPlugins.js.map